// extracted by mini-css-extract-plugin
export var text = "_43-0";